import React from 'react';
import Footer from '../Footer';

const Promoting = () => {
  return (
    <div>
      <h1 style={{ textAlign: "center", fontSize: "1.5rem", marginBottom: "20px", fontFamily: "Inter" }}>
        Promoting Alums
      </h1>
      
      <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
        <strong>Facilitating for getting Transcripts and Documents:</strong> TISSAA supports Alums by assisting with the process of 
        obtaining transcripts required for further studies, particularly for those applying to foreign universities. Through its website, 
        Alums can download the necessary forms and initiate the process with the academic department. TISSAA often follows up on these requests
         to ensure a smooth and timely resolution. This service strengthens the bond between TISS and its Alums while making essential academic
          documentation more accessible to Alums seeking further educational opportunities.
      </p>

      <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
        <strong>Publicity to Alums Work in Media and Social Platforms:</strong> TISSAA’s efforts to highlight Alums achievements through media
         outlets and social media platforms play a crucial role in increasing the visibility of TISS Alums and their impact. By featuring 
         detailed success stories in articles and posts, TISSAA showcases the diverse fields where Alums excel, such as research, academia,
          entrepreneurship, and the arts. These public recognitions inspire current students and strengthen TISS’s position as a premier 
          institution for social sciences. Through strategic media placements, TISSAA ensures that Alums contributions are celebrated and
           acknowledged on both national and international platforms.
      </p>

      <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
        <strong>Dhaaga Exhibition – Alums Involvement in Sustainable Initiatives:</strong> TISSAA’s collaboration with Alums like Anjali Wazir 
        and Archana Lawande to support Tata Power’s Dhaaga initiative exemplifies its commitment to promoting sustainable development through 
        Alums engagement. The Dhaaga initiative focuses on empowering women through micro-enterprises, sustainable livelihoods, and social 
        change. By organizing an exhibition on the TISS campus, TISSAA created a platform for Alums to reconnect with the institution while
         supporting a meaningful cause. This initiative highlights TISSAA’s role in bridging the gap between Alums and social enterprises, 
         creating opportunities for Alums to contribute to the empowerment of marginalized communities.
      </p>

      <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
        <strong>Connecting Alums Organizations with Resource Persons and Donor Agencies:</strong> TISSAA plays a crucial role in facilitating 
        connections between Alums organizations and essential resources, including professionals, donor agencies, and experts in various fields. 
        By facilitating these relationships, TISSAA helps Alums organizations access the expertise needed for research, documentation, proposal
         writing, and evaluations. These collaborations ensure that Alums-driven initiatives are well-supported, increasing their chances of 
         success and creating lasting social impact. Through its facilitation of professional networks and donor support, TISSAA fosters 
         collaboration and mutual benefit within the Alums community, ultimately driving positive change.
      </p>
      <Footer/>
    </div>
  );
};

export default Promoting;
